interface Paginated<T> {
  items: T[];
  totalItems: number;
  totalPages: number;
}

export const createDefaultPaginated = <T>(): Paginated<T> => ({
  items: [],
  totalItems: 0,
  totalPages: 0,
});

export default Paginated;
